import { FC } from 'react';

import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';

import styles from './BackgroundLogoIcon.styles.m.css';

export const BackgroundLogoIcon: FC = () => {
  return (
    <ImageTheme
      className={styles.logo}
      lightImageName={PROJECT_CONFIG.imageAssets.mainBackgroundLogoLight}
      darkImageName={PROJECT_CONFIG.imageAssets.mainBackgroundLogoDark}
    />
  );
};
